import { Link } from "react-router-dom";
import { ArrowDownTrayIcon } from "@heroicons/react/24/outline";

export function DownloadButton(props: { url: string; className?: string; disabled?: boolean }) {
	const className = props.className?.includes("btn-") ? props.className : "btn btn-neutral";
	return (
		<button className={className} disabled={props.disabled}>
			<Link
				className={`flex items-center !text-inherit !bg-inherit ${props.disabled ? "pointer-events-none cursor-not-allowed" : ""}`}
				to={props.url}
				download={true}>
				<ArrowDownTrayIcon className="size-4 mr-2" aria-hidden="true" />
				Download
			</Link>
		</button>
	);
}
